module.exports = __webpack_public_path__ + "img/SAC_Option4_background-buildings.775379bd.png";